import PropTypes from 'prop-types';

import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import PressPage from '../components/press-page/press-page';
import pressMenuHide from '../lib/press-menu-hide';
import { bootstrapApp } from '../lib/actions';

class PressRoute extends Component {
  componentDidMount() {
    pressMenuHide();
  }

  render() {
    return (
      <div>
        <DocumentTitle title="Press Room | NerdWallet" />
        <PressPage {...this.props} />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressRoute.displayName = 'PressRoute';
PressRoute.analyticsName = 'press_page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressRoute.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pressArticles: PropTypes.object.isRequired,
};

PressRoute.bootstrap = function bootstrap(store, req, res, callback) {
  store.dispatch(
    bootstrapApp({
      name: 'press-page',
      callback,
      query: req.query,
    })
  );
};

export default connect((state) => state)(PressRoute);
